module.exports = __webpack_public_path__ + "img/logo-muyullacta.d170104c.png";